// removed by extract-text-webpack-plugin
module.exports = {"block":"Pic__block-2f-S7","blockError":"Pic__blockError-2-lp2","image":"Pic__image-2EyCQ"};